import { datalabHttp, type TDatalabHttpConfig } from '@dbl/services/common';

import type {
  ICreateChartTagRequest,
  IGetChartLabelsRequest,
  IGetChartLabelsResponseDto,
  IGetChartTagListRequest,
  IGetChartTagListResponseDto,
} from './types';

/**
 * 获取图表 Tag 扁平列表（保存 / 复制图表时选择 `label`）。
 *
 * 无上传 prepare：请求体仅 `game_code`，直接传 wire。
 *
 * 原始实现：`getUserLabeList` @ `services/analysis.ts`
 */
export function getChartTagList(
  params: IGetChartTagListRequest,
): Promise<IGetChartTagListResponseDto> {
  return datalabHttp({
    url: '/api/v1/datalab/getUserLabelList',
    method: 'post',
    data: params,
  } as TDatalabHttpConfig);
}

/**
 * 创建图表 Tag（`createChart` 时写入的 `label` 值域来源）。
 *
 * 无上传 prepare：请求体仅 `game_code` + `label`，直接传 wire。
 *
 * 原始实现：`addUserLabeList` @ `services/analysis.ts`
 */
export function createChartTag(
  params: ICreateChartTagRequest,
): Promise<IGetChartTagListResponseDto> {
  return datalabHttp({
    url: '/api/v1/datalab/addUserLabel',
    method: 'post',
    data: params,
  } as TDatalabHttpConfig);
}

/**
 * 获取分组 Tag 树（我的分析 Category：任务权限 × 任务标签）。
 *
 * 后端对同一套 label 资源重新组装；Category 选中项组装为
 * {@link IGetChartListSubLabelRequest}[] 传给 `getChartList`。
 *
 * 无上传 prepare：请求体仅 `game_code`，直接传 wire。
 *
 * 原始实现：`pages/MyAnalyze/service.ts` -> getChartLabels
 */
export function getChartLabels(
  params: IGetChartLabelsRequest,
): Promise<IGetChartLabelsResponseDto> {
  return datalabHttp({
    url: '/api/v1/datalab/getChartLabels',
    method: 'post',
    data: params,
  } as TDatalabHttpConfig);
}
